import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Chambres from './pages/Chambres';
import Graphiques from './pages/Graphiques';
import AlarmesEvents from './pages/AlarmesEvents';
import Portes from './pages/Portes';
import Parametres from './pages/Parametres';
import NotFound from './pages/NotFound';
import { ProtectedRoutes } from './components/ProtectedRoutes';
import ChambreConfig from './pages/ChambreConfig';
import Login2 from './pages/Login2';

function App() {
    return (
        <Routes>
            <Route path="/" element={<Login2 />} />

            <Route path="/dashboard" element={
                <ProtectedRoutes>
                    <Chambres />
                </ProtectedRoutes>
            } />

            <Route path="/graphiques" element={
                <ProtectedRoutes>
                    <Graphiques />
                </ProtectedRoutes>
            } />

            <Route path="/alarmes&events" element={
                <ProtectedRoutes>
                    <AlarmesEvents />
                </ProtectedRoutes>
            } />

            <Route path="/portes" element={
                <ProtectedRoutes>
                    <Portes />
                </ProtectedRoutes>
            } />

            <Route path="/parametres" element={
                <ProtectedRoutes>
                    <Parametres />
                </ProtectedRoutes>
            } />

            <Route path="/dashboard/:roomId" element={
                <ProtectedRoutes>
                    <ChambreConfig />
                </ProtectedRoutes>
            } />

            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

export default App;